import http from '~/common/http'
export default {
    getList(params) {
        return http.get('/api/area-user/index', {
            params: params
        });
    },
    create(params) {
        return http.post("/api/area-user/create", params);
    },

    update(params) {
        return http.put("/api/area-user/update", params);
    },

    delete(id) {
        return http.delete("/api/area-user/delete", {
            params: {
                id: id
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/AreaUser.js